import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title" }, "Login", -1)
const _hoisted_6 = { class: "modal-card-body" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Username", -1)
const _hoisted_9 = { class: "control" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Passwort", -1)
const _hoisted_12 = { class: "control" }
const _hoisted_13 = { class: "modal-card-foot is-flex is-justify-content-space-around" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BulmaButton = _resolveComponent("BulmaButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("button", {
          class: "delete",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["left"]))
        })
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              ref: "username_input",
              class: "input",
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event))
            }, null, 512), [
              [_vModelText, _ctx.username]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event))
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ])
        ])
      ]),
      _createElementVNode("footer", _hoisted_13, [
        _createVNode(_component_BulmaButton, {
          class: "is-success",
          onClick: _withModifiers(_ctx.submit, ["left"]),
          icon: "fa-solid fa-unlock",
          text: "Login"
        }, null, 8, ["onClick"]),
        _createVNode(_component_BulmaButton, {
          class: "is-danger",
          onClick: _withModifiers(_ctx.cancel, ["left"]),
          icon: "fa-solid fa-circle-xmark",
          text: "Abbrechen"
        }, null, 8, ["onClick"])
      ])
    ])
  ]))
}